// FI-1871: apply a site theme by setting the data-fi-theme attribute that
// tokens.css resolves its semantic tokens against, and mirror it to
// localStorage so main.js can set it synchronously before first paint on the
// next load (no flash of the wrong theme). unknown values coerce to original.
const applyFiTheme = (value) => {
  const theme = (value === 'new' || value === 'midnight') ? value : 'original'
  try {
    document.documentElement.setAttribute('data-fi-theme', theme)
    localStorage.setItem('fi_theme', theme)
  } catch (_) {}
  return theme
}

const state = {
  user: {
    name: null
  },
  token: null,
  refresh_token: null,
  // admin-only UI preview flag: when set to 'non-admin', components that gate
  // on user.role === 'admin' should gate on effectiveRole instead so the admin
  // sees what a non-admin sees without logging out. persisted in localStorage
  // so the preference survives page reloads.
  view_as: (() => {
    try { return localStorage.getItem('view_as') || null } catch (_) { return null }
  })(),
  // FI-1871: per-user site theme (original | new | midnight). default
  // original; mirrored to localStorage and reflected on <html data-fi-theme>.
  site_theme: (() => {
    try { return localStorage.getItem('fi_theme') || 'original' } catch (_) { return 'original' }
  })(),
  // whether the user's starred pages also render as a strip under the
  // horizon top nav. same mirror-to-localStorage trick as site_theme so a
  // plain reload (no login round trip) still reads correctly from this
  // module's own IIFE default, before App.vue's created() runs.
  nav_favorites_bar: (() => {
    try { return localStorage.getItem('fi_nav_favorites_bar') === 'true' } catch (_) { return false }
  })()
}

const mutations = {
  set_user_data(state, user){
    state.user = user
  },
  set_view_as(state, value){
    state.view_as = value || null
    try {
      if (value) localStorage.setItem('view_as', value)
      else localStorage.removeItem('view_as')
    } catch (_) {}
  },
  set_site_theme(state, value){
    state.site_theme = applyFiTheme(value)
  },
  set_nav_favorites_bar(state, value){
    const enabled = !!value
    try { localStorage.setItem('fi_nav_favorites_bar', enabled ? 'true' : 'false') } catch (_) {}
    state.nav_favorites_bar = enabled
  },
}

export default {
  namespaced: true,
  state,
  mutations
}
